import * as React from "react"

const SvgDrop = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 21q-3.325 0-5.662-2.3Q4 16.4 4 13.1q0-1.625.625-3.037A8.2 8.2 0 0 1 6.35 7.55l4.6-4.525a1.7 1.7 0 0 1 .5-.312q.275-.113.55-.113t.55.113.5.312l4.6 4.525a8.2 8.2 0 0 1 1.725 2.513Q20 11.475 20 13.1q0 3.3-2.337 5.6T12 21m-5.95-7H17.9q.3-1.8-.337-3.075Q16.925 9.65 16.25 9L12 4.8 7.75 9q-.675.65-1.325 1.925T6.05 14" />
  </svg>
)
export default SvgDrop
